import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FALLBACK_TICKET_URL =
  "https://eventcartel.com/tours/vse-nashi-sxm-2nd-annual-music-festival-buy-tickets-1477";

export const fetchSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const fetchEvents = () => axios.get(`${API}/events`).then((r) => r.data);
export const fetchEvent = (slug) => axios.get(`${API}/events/${slug}`).then((r) => r.data);
export const fetchPackages = () => axios.get(`${API}/packages`).then((r) => r.data);

export const adminLogin = (password) =>
  axios.post(`${API}/admin/login`, { password }).then((r) => r.data);

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("smf_token")}` });

export const adminMe = () => axios.get(`${API}/admin/me`, { headers: authHeaders() }).then((r) => r.data);
export const updateEvent = (slug, data) =>
  axios.put(`${API}/admin/events/${slug}`, data, { headers: authHeaders() }).then((r) => r.data);
export const updatePackage = (slug, data) =>
  axios.put(`${API}/admin/packages/${slug}`, data, { headers: authHeaders() }).then((r) => r.data);
export const updateSettings = (data) =>
  axios.put(`${API}/admin/settings`, data, { headers: authHeaders() }).then((r) => r.data);
